// GENERATED BY scripts/gen-version.cjs — DO NOT EDIT.
// package.json is the single source; `prebuild` rewrites this file.
export const APP_VERSION = 'v242.359.0'
